module.exports = {
    'maintenance-summary': 'Maintenance Summary',
    'month': 'month',
    'year': 'year',
    'last-uploaded': 'Last Uploaded',
    'change-in-wells-since-last-month': 'Change In Wells Since Last Month',
    'change-in-asset-wells-since-last-month': 'Change In Wells For This Asset Since Last Month',
    'no-well-invoiced': 'No Well Invoiced',
    'no-maintenance-invoice-found': 'No Maintenance Invoice Found',
    'none': 'none',
}